import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const exabeam = defineConnector({
  identifier: "exabeam",
  name: "Exabeam",
  tagLine: "SIEM and security analytics platform",
  logo,
  protocol: "http",
  tags: ["security", "observability"],
  defaultUrlPattern: ({ domain }) =>
    domain ? `https://${domain.replace(/\./g, "\\.")}/.*` : "https://.*/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Exabeam, go to **Settings → Admin Operations → API Credentials** and create a new client. Copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Exabeam domain",
          required: true,
          placeholder: "api.us-west.exabeam.cloud",
          target: { kind: "configuration", field: "domain" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ domain }) => `https://${domain}/auth/v1/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${domain}/health-consumption/v1/health/appStatus`,
      expectedStatus: [200, 403],
    }),
  },
});
